module.exports = __webpack_public_path__ + "images/2-new.png?ab8b54074edd78c7e9854abbb9b00eb5";


//////////////////
// WEBPACK FOOTER
// ./src/pages/noko/info/2-new.png
// module id = 8fbf7fec0fea896c9f95
// module chunks = 47